// import BoxIcon from "../../../../../../../../../components/Icons/BoxIcon";
import React from "react";
import BoxIcon from "../Icons/BoxIcon";
import s from "./EmptyContainer.module.scss";

type Props = {
  title: string;
  subtitle: string;
};

export const EmptyContainer: React.FC<Props> = ({ title, subtitle }) => {
  return (
    <div className={s.wrapper}>
      <div className={s.icon}>
        <BoxIcon />
      </div>
      <div className={s.title}>{title}</div>
      <div className={s.text}>{subtitle}</div>
    </div>
  );
};
